<script setup lang="ts">
import { ref } from 'vue';
import { DebugPanelHelper } from '../../helpers/debugPanelHelper';

const props = defineProps({
  title: {
    type: String,
    default: 'Debug Panel'
  },
  initiallyExpanded: {
    type: Boolean,
    default: false
  }
});

const isExpanded = ref(props.initiallyExpanded);

const toggleExpand = () => {
  isExpanded.value = !isExpanded.value;
};
</script>

<template>
  <div v-if="DebugPanelHelper.enabled" class="debug-panel">
    <div class="debug-panel__header" @click="toggleExpand">
      <h3>{{ title }}</h3>
      <span class="debug-panel__toggle">
        {{ isExpanded ? '▼' : '&#9650;' }}
      </span>
    </div>
    <div v-if="isExpanded" class="debug-panel__content">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
.debug-panel {
  border: 2px dashed #ff5722;
  border-radius: 4px;
  margin: 8px 0;
  background-color: rgba(255, 87, 34, 0.05);
}

.debug-panel__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background-color: rgba(255, 87, 34, 0.1);
  cursor: pointer;
}

.debug-panel__header h3 {
  margin: 0;
  font-size: 1rem;
  color: #ff5722;
}

.debug-panel__toggle {
  font-weight: bold;
  color: #ff5722;
}

.debug-panel__content {
  padding: 12px;
  overflow: auto;
}
</style>
